import GlobalApprovals from './GlobalApprovals';

export default GlobalApprovals;
